export type FluzElementsErrorCode =
  | "MOUNT_TIMEOUT"
  | "MOUNT_FAILED"
  | "FIELD_ERROR"
  | "RATE_LIMITED"
  | "INVALID_STYLE"
  | "INVALID_FRAME_HOST_ORIGIN"
  | "INVALID_FIELD"
  | "INDIVIDUAL_REVEAL_DISABLED"
  | "NOT_IMPLEMENTED"
  | "SUBMIT_FAILED"
  | "SUBMIT_TIMEOUT";

export class FluzElementsError extends Error {
  readonly code: FluzElementsErrorCode;

  constructor(code: FluzElementsErrorCode, message: string) {
    super(message);
    this.name = "FluzElementsError";
    this.code = code;
  }
}
